$.userToolbar = function() {

'use strict';

	/**
	 *  variable to determine whether to display or remove user functions
	 * @type Boolean|Boolean|Boolean|Boolean|Boolean|Boolean
	 */
	var isMenuDisplayed = false;

	/**
	 * Stored the time when the key Ctrl+A was pressed
	 * @type Number|@exp;Date@call;now
	 */
	var usermenu1stKeyTime = 0;
	
	/**
	 * define the document click handler to remove the menu	when visible
	 */
	$(document).on('click', function(e) {
		// handle only when the click target is not a child of the menu or form
		if (isMenuDisplayed &&
			($(e.target).closest('#usermenu').length === 0 && $(e.target).closest('#changepwfrm').length === 0)) {
				$( '#loginimg' ).closest('a').trigger('click');
		}
	});

	/**
	 * define user-functions click handler
	 */
	$('#loginimg, #ws-webshopfunctions .ws-account, #showlogin').closest('a').on('click', function() {

		/**
		 * Function to log out the user
		 */
		function logout(){
			$('#usermenu').remove();

			isMenuDisplayed = false;
			if (confirm($.i81n.text('LOGOUTQUEST'))) {
				window.location = '/login.php?logout=1';
			}
			return false;
		}

		/**
		 * Function to display the password change form
		 */
		function changepw(){

			var $pwform = $('<form id="changepwfrm" style="z-index: 50000;" method="post" action="#">'
							+ '<div id="changemsg"></div>'
							+ '<div id="elems">'
							+ '<label for="f-oldpw">' + $.i81n.text('OLDPW') +'</label><br/>'
							+ '<input autofocus="" required type="password" name="oldpw" id="f-oldpw" value="" autocomplete="off" maxlength="32"><br/>'
							+ '<label for="f-newpw">' + $.i81n.text('NEWPW') +'</label><br/>'
							+ '<input type="password" required name="newpw" id="f-newpw" autocomplete="off" maxlength="32"><br/>'
							+ '<label for="f-newpwwh">' + $.i81n.text('REPEATPW') +'</label><br/>'
							+ '<input type="password" required name="newpwwh" id="f-newpwwh" autocomplete="off" maxlength="32"><br/><br />'
							+ '<div class="formbuttons">'
							+ '<input type="submit" id="changepwbtn" value="' + $.i81n.text('CHANGEPW') +'">'
							+ '<input id="cancelbtn" type="button" value=" ' + $.i81n.text('CANCEL') + ' " />'
							+ '</div>'
							+ '</div>'
							+ '</form>');
			// set buttons width
//			$pwform.find('#changepwbtn, #cancelbtn').css('min-width', '100px');
			
			$('#usermenu').slideUp(400, function(){
				$('#usermenu').remove();
				$('#loginimg').closest('nav').append($pwform);
				// trigger password switch generation
				$(document).trigger('moreJS:addPwSwitch');
				// ensure that the old password is empty
				$('#f-oldpw').val('');

				isMenuDisplayed  = true;

				$('#cancelbtn').on('click', function() {
					$('#loginimg').closest('a').trigger('click');
					return false;
				});
				
				$('#changepwfrm').on('submit', function(e) {
					e.preventDefault();
					var oldpw = $('#f-oldpw').val();
					var newpw = $('#f-newpw').val();
					var newpwwh = $('#f-newpwwh').val();
					var msgStyle = {'display': 'inline-block', 'padding':'10px', 'line-height':'120%', 'color':'green'};
					$.ajax({
						type: 'POST',
						url: '/changepw.php',
						data: 'oldpw=' + oldpw + '&newpw=' + newpw + '&newpwwh=' + newpwwh,
						success: function(status) {
							if (status === 'ok') {
								$('#elems').hide();
								$('#changemsg').html($.i81n.text('PWCHANGED')).css(msgStyle);
								$('#loginimg').closest('li').removeClass('active');
								setTimeout(function(){$('#changepwfrm').remove();}, 2000);
								isMenuDisplayed = false;
							}
							else {
								$('#changemsg').html('<span style="color:red">' + status + '</span>').css(msgStyle);;
								$('#elems').show();
								$('#f-oldpw, #f-newpw, #f-newpwwh').val('');
								$('#f-oldpw').focus();
							}
						},
						beforeSend: function() {
							$('#elems').hide();
							$('#changemsg').html($.i81n.text('PWCHANGING')).css(msgStyle);;
						},
						error: function( jqXHR, textStatus, errorThrown ) {
							$('#changemsg').html(textStatus + ': ' + errorThrown).css(msgStyle);;
						}
					});
					return false;
				});

				if($(window).width() < $('#pagehead').width()){
					$('#usermenu').css('left', 10);
				}else if($('#pagehead ul').width() < 230){
					$('#changepwfrm').css('left', $('#loginimg').closest('nav').width()-$('#loginimg').closest('ul').width()-186);
				}else{
					$('#changepwfrm').css('left', $('#loginimg').closest('nav').width()-$('#loginimg').closest('ul').width()-10);
				}

				$('#changepwfrm:hidden').slideDown();
				$('#f-oldpw').focus();

			});

		} // changepw
		
		/**
		 * Reset user cookies
		 * @param {Event} e 
		 */
		function resetCookies(e) { 
			e.preventDefault();
			location.href = '/creset.php'; 
		}		

		// define the menu
		var $menu = $('<ul id="usermenu" style="z-index: 50000;">'
			+ '<li id="logoutlnk"><a href="javascript:;" tabindex="0"><span class="userfunctions sprites_logout"></span>' + $.i81n.text('LOGOUT') + '</a></li>'
			+ (!$('#loginimg').hasClass('pwchangelock') 
					? '<li id="changepwlnk"><a href="javascript:;" tabindex="0"><span class="userfunctions sprites_changepw"></span>' + $.i81n.text('CHANGEPW') + '</a></li>' 
					: '')
			+ '<li id="creset"><a href="javascript:;" tabindex="0"><span class="userfunctions sprites_reset"></span>' + $.i81n.text('RESETCOOKIES') + '</a></li>'
			+ '</ul>');

		if(isMenuDisplayed === false){
			var posLeft = $('#loginimg').parent().offset().left;

			$('#loginimg').closest('nav').append($menu);

			$('#logoutlnk').on('click', logout);
			$('#changepwlnk').on('click', changepw);
			$('#creset').on('click', resetCookies);

			if(posLeft < 100){
				$('#usermenu').css('left', 10);
			}else{
				$('#usermenu').css('left', Math.min($('#loginimg').closest('nav').width() - $('#usermenu').outerWidth(), posLeft));
			}
			$('#usermenu:hidden').slideDown(function() {
				isMenuDisplayed = true;
				$('#usermenu a').first().focus();
			});

			$('#loginimg').closest('li').addClass('active');

			$('#usermenu a').first().focus();

		}else{

			$('#logoutlnk').off('click', logout);
			$('#changepwlnk').off('click', changepw);
			$('#creset').off('click').on('click', resetCookies);
			$('#usermenu').slideUp(400, function(){
				$(this).remove();
			});
			$('#loginimg').closest('li').removeClass('active');
			isMenuDisplayed = false;
			$('#changepwfrm').slideUp(400, function(){
				$(this).remove();
			});
		}

		return false;
	}); // user icon onclick

	/**
	 * define del page click handler
	 */
	$('#delpage').closest('a').on('click', function() {
		if (confirm($.i81n.text('DELPAGE') + '\n\n' + $.i81n.text('AREYOUSURE'))) {
			window.location.replace(window.location.href + (window.location.href.indexOf('?') > -1 ? '&' : '?') + 'delpage=1');
		}
		return false;
	});

	/**
	 * Handle key events like Escape, ctrl+S, ...
	 * @param {event} event
	 * @returns {undefined}
	 */
	function keyHandler(event) {
	//	console.log("keyHandler: " + event.which + 
	//				" shift: " + event.shiftKey + 
	//				" ctrl: " + event.ctrlKey);

		// F2, shift+F2
		if ((event.which === 113)) {

			// F2 - edit current page
			if (!event.shiftKey && !event.ctrlKey) {
				var $elem = $('#editpageimg');
				if ($elem.length > 0) {
					event.preventDefault();
					// call "edit page" link
					location = $('#editpageimg').closest('a').attr('href');
				} else {
					$.showMessiDlgToConfirm($.i81n.text('ERROR_TITLE'), $.i81n.text('CANTEDIT'), 'anim error', 
								{ callback: function() {
										$(':focus').first().focus();
									}
								});
				}
			// Shift+F2 - new page in current category/section
			} else if (event.shiftKey && !event.ctrlKey) {
				// call "new page" link if exists
				if ($('#newpageimg').length > 0) {
					event.preventDefault();
					location = $('#newpageimg').closest('a').attr('href');
				}
			}
		} else 
			// ctrl+A + Ctrl+A shows the usermenu
			if (event.which === 65 && event.ctrlKey) {
			event.preventDefault();
			if ((Date.now() - usermenu1stKeyTime) < 2000) {
				event.preventDefault();
				usermenu1stKeyTime = 0;
				$('#loginimg').trigger('click');
				return false;
			} else {
				usermenu1stKeyTime = Date.now();
			}			

		} else
			// esc handler for visible login form
			if (event.which === 27 && 
				!event.ctrlKey && !event.shiftKey && !event.altKey && !event.metaKey &&
				$('#usermenu, #changepwfrm').length > 0 ) {
			event.preventDefault();
			$(document).trigger('click');
		}
	}

	function changePwFrmHandler(e) {
		e.preventDefault();
		var $form = $(this);
		var oldpw = $('#f-oldpw').val();
		var newpw = $('#f-newpw').val();
		var newpwwh = $('#f-newpwwh').val();
		var msgStyle = {'display': 'inline-block', 'padding': '10px', 'line-height': '120%', 'color': 'green'};
		$.ajax({
			type: 'POST',
			url: '/changepw.php',
			data: 'oldpw=' + oldpw + '&newpw=' + newpw + '&newpwwh=' + newpwwh,
			success: function (status) {
				if (status === 'ok') {
					$('#elems').hide();
					$('#changemsg').html($.i81n.text('PWCHANGED')).css(msgStyle);
					;
					$('#loginimg').closest('li').removeClass('active');
					setTimeout(function () {
						if($form.hasClass('external')){
							history.back();
						}else{
							$('#changepwfrm').remove();	
						}
					}, 2000);
					isMenuDisplayed = false;
				} else {
					$('#changemsg').html('<span style="color:red">' + status + '</span>').css(msgStyle);
					;
					$('#elems').show();
					$('#f-oldpw, #f-newpw, #f-newpwwh').val('');
					$('#f-oldpw').focus();
				}
			},
			beforeSend: function () {
				$('#elems').hide();
				$('#changemsg').html($.i81n.text('PWCHANGING')).css(msgStyle);
				;
			},
			error: function (jqXHR, textStatus, errorThrown) {
				$('#changemsg').html(textStatus + ': ' + errorThrown).css(msgStyle);
				;
			}
		});
		return false;
	};

	/**
	 * bind key handler
	 * <!> It is important to use keyDown event to catch the standard browser 
	 * key bindings!
	 */
	$(window).on('keydown', keyHandler);
	
	// put handler on change password form on page load (for changepass.php)
	$('#changepwfrm').on('submit', changePwFrmHandler);

	// remove userlogin elements 
	$('.userlogincontainer, .userloginlink').remove();
	
};
